import { render, staticRenderFns } from "./AModalConvenioSelect.vue?vue&type=template&id=4b878ed9&scoped=true"
import script from "./AModalConvenioSelect.vue?vue&type=script&lang=js"
export * from "./AModalConvenioSelect.vue?vue&type=script&lang=js"
import style0 from "./AModalConvenioSelect.vue?vue&type=style&index=0&id=4b878ed9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b878ed9",
  null
  
)

export default component.exports